var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 47,
    viewBox: "0 0 66 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.7059 26.7305C58.2696 26.1646 57.4571 26.0594 56.8908 26.4958C56.3247 26.9321 56.2196 27.7448 56.656 28.3108C57.9864 30.0366 58.6896 32.1039 58.6896 34.289C58.6896 35.0036 59.269 35.583 59.9837 35.583C60.6984 35.583 61.2778 35.0035 61.2778 34.289C61.2778 31.5269 60.3885 28.9132 58.7059 26.7305Z",
    fill: "url(#paint0_linear_1919_7043)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.3567 18.0417C56.9842 16.2684 58.7154 13.2639 58.7154 9.86275C58.7154 4.42458 54.2911 0.000257671 48.8529 0.000257671C43.4147 0.000257671 38.9904 4.42458 38.9904 9.86275C38.9904 13.2624 40.7199 16.2656 43.3455 18.0394C41.4328 18.6869 39.642 19.6729 38.0521 20.9657C36.7068 19.6719 34.9014 18.9267 33.0001 18.9267C31.099 18.9267 29.2936 19.6721 27.9491 20.9657C26.3586 19.6729 24.5676 18.6869 22.6546 18.0393C25.2802 16.2655 27.0097 13.2623 27.0097 9.86249C27.0097 4.42432 22.5854 0 17.1472 0C11.7097 0 7.28604 4.42432 7.28604 9.86249C7.28604 13.2637 9.01686 16.268 11.644 18.0415C4.89083 20.3361 0.0163711 26.733 0.00180469 34.2491C0.00141797 34.2606 0 34.2714 0 34.2827C0 36.2696 1.12896 39.2018 6.5077 41.8882C10.3403 43.8025 15.6072 45.2415 21.739 46.0493C25.3358 46.5237 29.1246 46.7644 33.0001 46.7644C36.8766 46.7644 40.6658 46.5238 44.2624 46.0493C50.3937 45.2415 55.6602 43.8025 59.4927 41.8882C64.871 39.2017 66 36.2696 66 34.2827C66 26.7522 61.1203 20.3399 54.3567 18.0417ZM41.5787 9.86275C41.5787 5.8517 44.842 2.58857 48.8529 2.58857C52.8638 2.58857 56.1271 5.85183 56.1271 9.86275C56.1271 13.8731 52.8638 17.1356 48.8529 17.1356C44.842 17.1356 41.5787 13.8731 41.5787 9.86275ZM29.1387 23.5367C30.018 22.2709 31.4612 21.515 33 21.515C34.5395 21.515 35.9833 22.2709 36.8624 23.5367C36.8625 23.5371 36.8628 23.5374 36.8629 23.5376C37.4116 24.3264 37.7013 25.2526 37.7013 26.2164C37.7013 28.8089 35.5923 30.9179 32.9999 30.9179C30.4081 30.9179 28.2997 28.8087 28.2997 26.2163C28.2997 25.2511 28.5893 24.3251 29.1387 23.5367ZM9.87409 9.86275C9.87409 5.8517 13.1367 2.58857 17.147 2.58857C21.158 2.58857 24.4212 5.85183 24.4212 9.86275C24.4212 13.8731 21.1579 17.1356 17.147 17.1356C13.1367 17.1356 9.87409 13.8731 9.87409 9.86275ZM20.6146 43.2754C15.3958 42.4807 10.9408 41.2093 7.66438 39.5728C4.40047 37.9428 2.59939 36.07 2.58895 34.2982C2.58895 34.2931 2.58973 34.288 2.58973 34.2829C2.5896 26.2551 9.12012 19.7239 17.1471 19.7239C20.5621 19.7239 23.8202 20.9037 26.4275 23.0645C25.9573 24.0415 25.7116 25.1126 25.7116 26.2166C25.7116 28.4695 26.7392 30.4867 28.3497 31.825C23.8263 33.6641 20.6263 38.1021 20.6146 43.2754ZM42.7991 43.6217C39.6513 43.989 36.3614 44.1763 33 44.1763C29.6394 44.1763 26.35 43.989 23.2022 43.6217V43.304C23.2022 37.9014 27.5974 33.5062 33 33.5062C38.4032 33.5062 42.7991 37.9014 42.7991 43.304V43.6217ZM58.336 39.5727C55.0599 41.2093 50.6054 42.4805 45.3871 43.2752C45.3754 38.102 42.1752 33.6643 37.6513 31.8249C39.2623 30.4866 40.29 28.4693 40.29 26.2163C40.29 25.1136 40.0443 24.0423 39.5737 23.0644C42.1798 20.9034 45.4375 19.7237 48.8531 19.7237C56.8808 19.7238 63.4118 26.255 63.4118 34.2826C63.4118 36.0592 61.6092 37.9379 58.336 39.5727Z",
    fill: "url(#paint1_linear_1919_7043)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.8243 23.6797C53.159 23.6797 53.156 26.2679 54.8243 26.2679C56.4898 26.2679 56.4925 23.6797 54.8243 23.6797Z",
    fill: "url(#paint2_linear_1919_7043)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1919_7043",
    x1: 56.3867,
    y1: 26.2266,
    x2: 61.5178,
    y2: 26.3601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1919_7043",
    x1: 0,
    y1: 0,
    x2: 68.945,
    y2: 4.84351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1919_7043",
    x1: 53.5742,
    y1: 23.6797,
    x2: 56.1929,
    y2: 23.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AC9C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamily);
export default __webpack_public_path__ + "static/media/icon-family.4dd9b6cc8f01f6ba741d3da24edac239.svg";
export { ForwardRef as ReactComponent };